import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SendByIdPayload,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { ArticleVideoContentPayload } from '../models/video-content-payload';

export const ArticleVideoContentEditActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[article/video-content] Edit'),
  requestFail: uniqueActionType('[article/video-content] Edit fail'),
  requestSuccess: uniqueActionType('[article/video-content] Edit success'),
  requestClearErrors: uniqueActionType('[article/video-content] Edit clear errors'),
  requestClear: uniqueActionType('[article/video-content] Edit clear')
};

export class ArticleVideoContentEditAction implements PayloadAction {
  readonly type = ArticleVideoContentEditActionTypes.request;

  constructor(public payload: SendByIdPayload<ArticleVideoContentPayload>) {
  }
}

export class ArticleVideoContentEditFailAction implements PayloadAction {
  readonly type = ArticleVideoContentEditActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class ArticleVideoContentEditSuccessAction implements PayloadAction {
  readonly type = ArticleVideoContentEditActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class ArticleVideoContentEditClearErrorsAction implements PayloadAction {
  readonly type = ArticleVideoContentEditActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}

export class ArticleVideoContentEditClearAction implements PayloadAction {
  readonly type = ArticleVideoContentEditActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}
